import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class ArticleCategory<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: string;
  /** Alias: level */
  level?: number;
  /** Alias: index */
  index?: number;

  __typename?: string;
}

const fields: FieldDefinitions<ArticleCategory> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  level: {
    alias: 'level',
  },
  index: {
    alias: 'index',
  },
  __typename: {
    alias: '__typename',
  },
};

export const articleCategoryEntityDefinition: EntitiyDefinition<ArticleCategory> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ArtikelKategorie',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
